import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {push} from 'react-router-redux';
import Transition from 'react-inline-transition-group';
import {Radio} from 'rmwc';

import * as defaultStyles from '../../styles';
import {imageUrl} from '../../utilities/requests';
import {request} from '../../containers/actions';
import * as actions from './actions';


export default class Summary extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        type: false,
    }

    componentDidUpdate(prevProps) {
        this.props.store.getIn(['main', 'items']).forEach((__, key) => {
            if (
                prevProps.store.getIn(['main', 'items', key, 'count']) !== this.props.store.getIn(['main', 'items', key, 'count'])
            ) {
                this.setState(
                    {type: this.props.store.getIn(['main', 'items', key, 'item', 'virtual'])},
                    () => this.refs[key].scrollIntoView(),
                );
            }
        });
    }

    render() {
        const itemTypes = this.props.store.getIn(['main', 'items']).map(item => item.getIn(['item', 'virtual'])).toSet().toArray();
        const type = this.props.summary
            ? itemTypes.length === 1 ? itemTypes[0] : this.state.type
            : this.props.location.query.type ? this.props.location.query.type === 'virtual' : itemTypes[0];
        const items = this.props.store.getIn(['main', 'items']).filter(item => item.getIn(['item', 'virtual']) === type);
        return <div
            style={{
                marginBottom: '.25em',
                width: this.props.summary ? '14em' : undefined,
            }}
            onClick={event => {
                if (this.props.summary)
                    event.stopPropagation();
            }}>
            {itemTypes.length === 2 && this.props.summary
                ? <div style={{backgroundColor: 'white'}}>
                    <Radio
                        checked={type === false}
                        onChange={() => this.setState({type: false})}
                        label={window.gettext('Physical Cart')}
                    />
                    <br/>
                    <Radio
                        checked={type === true}
                        onChange={() => this.setState({type: true})}
                        label={window.gettext('Virtual Cart')}
                    />
                </div>
                : null
            }
            <div
                ref='list'
                style={{
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    maxHeight: (
                        this.props.summary &&
                        this.context.store.getState().getIn(['application', 'token', 'accessToken'])
                    )
                        ? '16em'
                        : '21em',
                    backgroundColor: 'white',
                }}>
                <Transition
                    childrenStyles={{
                        base: {
                            opacity: 0,
                            backgroundColor: 'white',
                            transition: 'opacity 700ms, background-color 700ms',
                        },
                        appear: {
                            opacity: 1,
                        },
                        enter: {
                            opacity: 1,
                        },
                        leave: {
                            opacity: 0,
                            backgroundColor: 'rgb(255, 210, 210)',
                            transition: 'opacity 700ms',
                        },
                    }}>
                    {items.sortBy(item => item.get('timestamp')).map(
                        (item, index) => <div
                            ref={item.getIn(['item', 'id'])}
                            key={item.getIn(['item', 'id'])}
                            style={{
                                overflow: 'hidden',
                                padding: '.5em',
                                float: 'right',
                                width: '14em',
                                ...((Date.now() - item.get('editTimestamp')) < 1200
                                    ? {backgroundColor: 'rgb(213, 255, 222)'}
                                    : {}
                                ),
                                borderBottom: index < items.size - 1
                                    ? '.0625em solid #cacaca'
                                    : null,
                            }}>
                            {this.props.active || this.props.summary
                                ? <i
                                    style={{float: 'right', cursor: 'pointer', width: '.75em'}}
                                    className='fa-times'
                                    onClick={() => this.context.store.dispatch(actions.removeFromCart(item.get('item').toJS()))}>
                                </i>
                                : null
                            }
                            <img
                                style={{
                                    width: '3em',
                                    height: '4em',
                                    verticalAlign: 'top',
                                    marginRight: '.5em',
                                    marginLeft: '.5em',
                                    float: 'right',
                                }}
                                src={imageUrl(item.getIn(['item', 'final_image']), {
                                    width: 48,
                                    height: 64,
                                    type: 'cover',
                                })}
                            />
                            <div style={{float: 'right', fontSize: '.9em', width: 'calc(100% - 4.75em/.9)'}}>
                                <div style={{width: '100%', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                    {item.getIn(['item', 'caption'])}
                                </div>
                                <div style={{fontSize: '.85em'}}>
                                    <div style={{float: 'right'}}>
                                        {window.gettext('Count')}:&nbsp;
                                    </div>
                                    {(this.props.active || this.props.summary) && !item.getIn(['item', 'virtual'])
                                        ? [
                                            <input
                                                key={item.getIn(['item', 'id']) + '-count'}
                                                style={{
                                                    ..._.pickBy(defaultStyles.field, (value, key) => key !== 'padding'),
                                                    height: undefined,
                                                    float: 'right',
                                                    marginBottom: '0',
                                                    width: '3em',
                                                    fontSize: '1em',
                                                    paddingTop: '0',
                                                    paddingBottom: '0',
                                                    paddingLeft: '.5em',
                                                    paddingRight: '.5em',
                                                }}
                                                value={item.get('count').persian()}
                                                onChange={({target: {value}}) => {
                                                    value = value.english();
                                                    if (isNaN(Number.parseInt(value)) && value.length > 0)
                                                        return;
                                                    if (Number.parseInt(value) > 1000)
                                                        return;
                                                    if (Number.parseInt(value) < 0)
                                                        return;
                                                    this.context.store.dispatch(actions.setCount(
                                                        item.get('item').toJS(),
                                                        Number.parseInt(value) || '',
                                                    ));
                                                }}
                                            />,
                                            <button
                                                key='+'
                                                style={{
                                                    ...defaultStyles.button,
                                                    padding: '.4em',
                                                    marginRight: '.3em',
                                                    float: 'right',
                                                    backgroundColor: 'white',
                                                    minWidth: undefined,
                                                }}
                                                onClick={() => this.context.store.dispatch(actions.setCount(
                                                    item.get('item').toJS(),
                                                    (Number.parseInt(item.get('count')) || 0) + 1,
                                                ))}>
                                                <i className='fa-plus'></i>
                                            </button>,
                                            <button
                                                key='-'
                                                style={{
                                                    ...defaultStyles.button,
                                                    padding: '.4em',
                                                    marginRight: '.3em',
                                                    float: 'right',
                                                    backgroundColor: 'white',
                                                    minWidth: undefined,
                                                }}
                                                onClick={() => this.context.store.dispatch(actions.setCount(
                                                    item.get('item').toJS(),
                                                    Math.max((Number.parseInt(item.get('count')) || 0) - 1, 1),
                                                ))}>
                                                <i className='fa-minus'></i>
                                            </button>,
                                        ]
                                        : <div style={{float: 'right'}}>
                                            {item.get('count').persian()}
                                        </div>
                                    }
                                </div>
                                <div style={{fontSize: '.85em', clear: 'right'}}>
                                    {window.gettext('Price')}:&nbsp;
                                    {(item.getIn(['item', 'price'])
                                        ? (item.getIn(['item', 'price']) - (item.getIn(['item', 'price']) * item.getIn(['item', 'off']) / 100)) * item.get('count')
                                        : '-'
                                    ).persian()} {window.gettext('Tooman')}
                                </div>
                            </div>
                        </div>
                    ).toArray()}
                </Transition>
            </div>
            <div style={{padding: '.5em', backgroundColor: 'white', marginTop: '.125em'}}>
                {window.gettext('Total Price')}:&nbsp;
                <span style={{fontWeight: items.size !== 0 ? '800' : undefined}}>
                    {items.reduce(
                        (sum, item) => sum + (item.getIn(['item', 'price']) - (item.getIn(['item', 'price']) * item.getIn(['item', 'off']) / 100)) * item.get('count'),
                        0,
                    ).persian()} {window.gettext('Tooman')}
                </span>
                &nbsp;
                <span style={{fontSize: '.8em'}}>
                    ({items.reduce(
                        (sum, item) => sum + item.get('count'),
                        0,
                    ).persian()} {window.pgettext('cart', 'Items')})
                </span>
            </div>
            {items.size !== 0 && (this.props.active || this.props.summary)
                ? <div
                    style={this.props.summary
                        ? {display: 'flex', justifyContent: 'center', width: '100%', marginTop: '.5em'}
                        : {}}>
                    <button
                        style={{
                            ...(this.props.summary ? defaultStyles.button : defaultStyles.defaultButton),
                            backgroundColor: this.props.summary
                                ? 'rgba(255, 255, 255, .4)'
                                : defaultStyles.defaultButton.backgroundColor,
                            marginLeft: this.props.summary ? undefined : '.5em',
                            borderRadius: this.props.summary ? '.5em' : defaultStyles.defaultButton.borderRadius,
                            color: this.props.summary ? 'white' : defaultStyles.defaultButton.color,
                            float: this.props.summery ? undefined : 'left',
                        }}
                        onClick={async () => {
                            if (this.props.summary) {
                                try{
                                    const response = await this.context.store.dispatch(request({
                                    path: '/order/register_incomplete_order/',
                                        body: {items: items.toArray()},
                                    method: 'POST',
                                    }));
                                    if (response.error){
                                        alert(response.error)
                                        return;
                                    }
                                }catch(exception){
                                    this.context.store.dispatch([
                                        push(`/store/purchase/summary/?type=${type ? 'virtual' : 'physical'}`),
                                    ]);
                                }
                                this.context.store.dispatch([
                                    push(`/store/purchase/summary/?type=${type ? 'virtual' : 'physical'}`),
                                ]);
                            }
                            else
                                this.context.store.dispatch(push({
                                    pathname: '/store/purchase/next/',
                                    query: this.props.location.query,
                                }));
                        }}>
                        {this.props.summary ? window.gettext('Finalize purchase') : window.gettext('Confirm')}
                    </button>
                </div>
                : null
            }
        </div>;
    }
}
